enum PageTitle {
  ActivitiesList = 'activities list',
  CreateMap = 'create map',
  ExploreList = 'explore list',
  ExploreMap = 'explore map',
  ExploreMapDetails = 'explore map details',
  ExploreRecording = 'explore recording',
  ExploreRecordingDetails = 'explore recording details',
  ExploreSearch = 'explore search',
  ExploreTrail = 'explore trail',
  MapsList = 'maps list',
  TrailDetails = 'trail details',
  Unknown = 'unknown'
}

export default PageTitle;
